<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>统计</el-breadcrumb-item>
      <el-breadcrumb-item>工时统计</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <div class="filters">
        时间筛选
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          align="right"
          value-format="yyyy-MM-dd"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          :clearable="false"
        ></el-date-picker>
      </div>
      <div class="table-responsive">
        <table
          v-if="results.length > 0"
          class="table table-striped table-vcenter"
        >
          <thead>
            <tr>
              <th>人员姓名</th>
              <th>任务数量</th>
              <th>所有工时</th>
              <th class="text-center">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(result, index) in results">
              <td>{{ result.user_name }}</td>
              <td>{{ result.task_count }}</td>
              <td>{{ result.total }}</td>
              <td class="text-center actions">
                <router-link
                  class="text-primary"
                  :to="
                    '/statistics/manhour_detail?user_id=' +
                    result.user_id +
                    '&user_name=' +
                    result.user_name +
                    '&start_time=' +
                    dateRange[0] +
                    '&end_time=' +
                    dateRange[1]
                  "
                  >查看详细</router-link
                >
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else>此时间段内无任务</div>
      </div>
    </div>
  </div>
</template>

<script>
import { manhourStatistics, manhourDetailStatistics } from '@/service/getData'
import flowEditor from '@/views/produce/flow/flow_editor'
import { formatTime } from '@/utils/index'

export default {
  components: { flowEditor },
  data() {
    return {
      results: [],
      startTime: null,
      endTime: null,
      detailVisible: false,
      selectUser: null,
      dateRange: null,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  watch: {
    dateRange(newv) {
      if (newv) {
        this.requestStatistics()
      }
    },
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      let end_time = this.$route.query.end_time || new Date()
      let start_time =
        this.$route.query.start_time ||
        new Date(end_time.getTime() - 30 * 24 * 3600 * 1000)

      start_time = formatTime(start_time, 'YYYY-MM-DD')
      end_time = formatTime(end_time, 'YYYY-MM-DD')
      this.dateRange = [start_time, end_time]
      this.requestStatistics()
    },
    async requestStatistics() {
      this.startTime = this.dateRange[0]
      this.endTime = this.dateRange[1]

      this.$router
        .replace({
          query: { start_time: this.startTime, end_time: this.endTime },
        })
        .catch((err) => {
          err
        })

      let data = {
        start_time: this.startTime + ' 00:00:00',
        end_time: this.endTime + ' 23:59:59',
      }
      let res = await manhourStatistics(data)
      this.results = res.data.list
    },
  },
}
</script>

<style scoped>
.filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.actions span {
  display: inline-block;
  margin-right: 1em;
  cursor: pointer;
}
</style>